module.exports = __webpack_public_path__ + "static/Brian-3aa7062b6002c2b5de07887255dd8c0d.mp4";